// Host
// Make sure DEV_HOST_URL assigned when deployed
export const CURRENT_HOST_URL = process.env.REACT_APP_HOST_URL;

// Authentication
export const LOGIN_URL = `/api/token/login?`;
export const REFRESH_TOKEN_URL = `/api/token/refresh?`;
export const LOGOUT_URL = `/api/token/logout`;
export const GET_USER_URL = `/api/token/getuseraccounts`;
export const RESET_PASSWORD = `/api/token/resetpassword`;

// Invoice
export const INVOICE_LIST_URL = `/api/Invoice`;
export const INVOICE_DETAIL_URL = `/api/invoice/detail`;
export const INVOICE_PDF_URL = `/api/Invoice/pdf-request`;
export const INVOICE_SEARCH_PDF_URL = `/api/invoice/search-pdf-request`;
export const PAYMENT_URL = `/api/invoice/payments`;
export const INVOICE_BULK_URL = '/api/Invoice/bulk-pdf-request';

// Customer
export const PAYER_DETAILS_URL = `/api/customer/payer`;
export const CUSTOM_DATA_URL = `/api/customer/customizing`;
export const USER_PAYERS_URL = `/api/customer/getuserpayers?`;
export const MANAGE_PAYMENTS_URL = `/api/customer/payment_cards?`;
export const DEPOSIT_URL = `/api/customer/makedeposit`;

// Payment Methods
export const GET_PAYMENT_ACCESS_TOKEN = `/api/tokenization/access_token?`;
export const GET_PAYMENT_RESPONSE = `/api/tokenization/response?`;

// User Management
export const GET_USER_LIST = '/api/users';
export const EXPORT_USERS = '/api/users/export';

// AccountType Management
export const GET_ACCOUNT_TYPE_LIST = '/api/configuration/getaccounttypes';
export const GET_PRIMARY_ACCOUNT_TYPE_LIST = '/api/configuration/getprimaryaccounttypes';
